import { action, observable } from 'mobx';
import * as loginUtil from '../Utils/loginUtil';
import PAGE_URLS from '../Constant/pageUrls';
import URLS from '../Constant/urls';
import storage from './storage';
import { RootStoreInterface } from './index';
import { qav } from '../Utils/qav';
import { fetch } from '../Utils/fetch';
import { navigate } from '../Utils/navigate';
import {PopViewType} from '../Utils/PopViewManager';
import { DeviceInfo } from 'qunar-react-native'
// import {NPM_ORDER_VERSION} from "../Views/OrderList/store";
import {CLIENT_VERSION} from "../Views/OrderList/store";

const { isWeb, isMini, scheme } = DeviceInfo

// 只有一期业务线需要有绑定入口
const availableMap: { [propName: string]: boolean } = {
    bus: true,
    flight: true,
    train: true,
    hotel: true,
    hotelAll: true,
    ddr: true,
    sight: true,
    all: true,
    carcar: true,
    new_apartment: true,
    food: true
};
const unavailableBusiness = ['directbus', 'pack'];

const deleteUnavailable = (businessType: string) => {
    // 过滤不支持的business
    const businessTypeList = businessType?.split(',') || [];
    const resultList: string[] = [];
    if (businessTypeList?.length) {
        businessTypeList.forEach((val) => {
            if (unavailableBusiness.indexOf(val) === -1) {
                resultList.push(val);
            }
        });
    }
    return resultList.join(',');
};

export interface BindNoticeInterface {
    rootStore: RootStoreInterface;
    abort: () => any;
    showBindNotice: boolean;
    unbindAlertVisiable: boolean;
    toggleShowBindNotice(showBindNotice: boolean): void;
    toggleUnbindAlert(unbindAlertVisiable: boolean): void;
    checkBindOrder(businessId: string, businessValue: string): void;
    openBindView(): void;
}

class BindNotice {
    public rootStore: RootStoreInterface;

    public abort: () => any = null;

    // 展示上方订单绑定提示条
    @observable
    public showBindNotice = false;

    // 未绑定 alert 是否可见
    @observable
    public unbindAlertVisiable = false;

    public constructor(rootStore: RootStoreInterface) {
        this.rootStore = rootStore;
    }

    @action
    public toggleShowBindNotice = (showBindNotice: boolean) => {
        this.showBindNotice = showBindNotice;
        if (showBindNotice) {
            qav({
                page: this.rootStore.pageName,
                module: 'bindNotice',
                path: [{ title: '订单绑定提示条展示', position: '0' }],
                operType: 'show'
            });
        }
    };

    @action
    public toggleUnbindAlert = (unbindAlertVisiable: boolean) => {
        this.unbindAlertVisiable = unbindAlertVisiable;
        if (unbindAlertVisiable) {
            qav({
                page: this.rootStore.pageName,
                module: 'bindNoticeAlert',
                path: [{ title: '订单绑定提示弹窗展示', position: '0' }],
                operType: 'show'
            });
        }
    };

    // 判断是否需要显示绑定订单提示
    public checkBindOrder = async (businessId: string, businessValue: string) => {
        this.abort && this.abort();
        const isLogin = await loginUtil.isLogin();

        if (!isLogin) {
            return;
        }

        if (availableMap[businessId]) {
            try {
                const response = await fetch(
                    {
                        url: URLS.orderlist,
                        method: 'POST',
                        body: {
                            limit: 1,
                            // npmOrderVer: NPM_ORDER_VERSION,// 添加NPM组件版本号，供后端作版控使用
                            clientVersion:CLIENT_VERSION,// 添加接口版本号，1-机票合单
                            businessTypes: deleteUnavailable(businessValue),
                            userNameQuery: false,
                            localQuery: true,
                            userPhoneQuery: true,
                            unbindQuery: true,
                            queryScene: 1 // 只查一年内订单
                        },
                        requestType: 'form'
                    },
                    (abort: () => any) => {
                        this.abort = abort;
                    },
                    this.rootStore.hyId,
                );

                const { status, data } = response;

                if (status === 0 && data && data.orderList && data.orderList.length) {
                    // 有未绑定订单
                    const hasShowBindConfirm = await storage.getItem('hasShowBindConfirm');
                    if (!hasShowBindConfirm && isLogin) {
                        // this.toggleUnbindAlert(true);
                        if(this.rootStore.uiState.isJourneyInnerModule){
                            this.rootStore.popViewManager.addPopView(PopViewType.popViewTypeBindAlert)
                            this.rootStore.checkPopViewFunc && this.rootStore.checkPopViewFunc()
                            // console.log('*******')
                        }else{
                            // console.log('显示111')
                            this.toggleUnbindAlert(true);
                        }
                    } else {
                        // console.log('显示2222')
                        this.toggleShowBindNotice(true);
                    }
                } else {
                    // console.log('隐藏')
                    this.toggleShowBindNotice(false);
                }
            } catch (err) {
                // console.log('隐藏')
                this.toggleShowBindNotice(false);
            }
        }
    };

    public openBindView = () => {
        const { businessValue, sourceFrom } = this.rootStore.uiState;
        this.rootStore.needRefresh = true;
        // ! 这里的isWeb指的是订单列表页是否为web，并不是指二级页
        if(isWeb){
            window.location.href = `https://touch.qunar.com/mordercenter/v2/index.html?hybridid=mob_ordercenter&new_r=${Math.random()}#bindList?businessType=flight%2Ctrain%2Cbus%2Chotel%2Chotel_sight%2Ctese%2Chuiyi%2Cticket%2Cfood%2Cicar%2Ccar%2Ctravel%2Clocal%2Cinsure%2Cqmall%2Cshopping%2Cbnb&source=touch#`
        }else if(isMini){
            Ext.Router.Bridge.sendScheme({url:`${scheme}://pcenter/launchMiniProgram?path=${encodeURIComponent(`/pages/platform/noOrderList/index`)}`})
        }else{
            navigate({
                url: `${PAGE_URLS.bindList}?businessType=${businessValue}&source=${sourceFrom}&fromPageType=rn`,
                type: 'navibar-none'
            });
        }
    };
}

export default BindNotice;
